module.exports = __webpack_public_path__ + "static/media/58.e664b762.jpg";